{
  "name": "dotenvxjs",
  "version": "0.0.12",
  "description": "dotenvx is the official Node.js library for .envx files, offering advanced type validation, intelligent interpolation, and conditional logic. It makes environment management safer, more dynamic, and easier to maintain.",
  "bin": {
    "dotenvx": "./dist/cli/index.js"
  },
  "main": "./dist/src/index.js",
  "module": "./dist/src/index.mjs",
  "types": "./dist/src/index.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "examples-test": "ts-node ./examples/index",
    "build": "tsup",
    "test": "jest",
    "test:watch": "jest --watch"
  },
  "keywords": [
    "dotenv",
    "env",
    "environment",
    "config",
    "configuration",
    "environment-variables",
    "env-loader",
    "type-validation",
    "interpolation",
    "conditional",
    "typescript",
    "nodejs",
    "env-parser",
    "dotenvx",
    "safe-config",
    "config-validation"
  ],
  "author": "trymagic",
  "license": "MIT",
  "devDependencies": {
    "@types/jest": "^29.5.14",
    "@types/lodash.debounce": "^4.0.9",
    "@types/node": "^22.15.29",
    "jest": "^29.7.0",
    "ts-jest": "^29.3.4",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3"
  },
  "dependencies": {
    "chokidar": "^4.0.3",
    "colorette": "^2.0.20",
    "commander": "^14.0.0",
    "lodash.debounce": "^4.0.8"
  }
}
